import React, { useRef } from "react";
import { useActivateTooltip } from "@/aible/Tooltip/useActivateTooltip";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/aible/Tooltip/Tooltip";
const CellWithTooltip = ({ children, className, tooltip }) => {
    const ref = useRef(null);
    const showTooltip = useActivateTooltip(ref);
    if (!showTooltip) {
        return (React.createElement("div", { ref: ref, className: className }, children));
    }
    return (React.createElement(Tooltip, null,
        React.createElement(TooltipTrigger, { asChild: true },
            React.createElement("div", { ref: ref, className: className }, children)),
        React.createElement(TooltipContent, null, tooltip)));
};
export default CellWithTooltip;
